import React, {useEffect, useState} from 'react';
import {NeuroMessage, usePages, AnswersList, RenderOnlyFor, updateProductCart, addAllProducts, useDispatch, useProducts, ContactFormModal, useNeuroState} from '@ignitesales/neuro-application';
import CartModal from '../CartModal.jsx';
import Product from "../Product.jsx";
import { getProductsInCartMap, getProductsInCartLists} from '../../utils/productUtil.js';
import { getBankSaved, getMarketSaved } from '../../utils/getBank.js';
import { getParams } from '../../utils/getParams.js';
import { saveAppkey } from '../../utils/answerHelpers.js';
import Collapsible from "react-collapsible";
import ReactSVG from 'react-svg';
import ContactForm from '../ContactFormModal';

function SummaryPage({ componentClass, productsList }) {
    const { goToPreviousPage } = usePages();
    const dispatch = useDispatch();
    const [ showCartModal, setShowCartModal ] = useState(false);
    const [ showContactModal, setShowContactModal ] = useState(false);
    const { productCart } = useProducts();
    const [ productsInTheCart, getProductsInTheCart ] = useState(getProductsInCartMap(productCart, productsList));
    const [allCartList, setAllCartList] = useState([]);
    const [contactCartList, setContactCartList] = useState([]);
    const [applyCartList, setApplyCartList] = useState([]);
    const { answers } = useNeuroState();
    const bankFromUrl = getParams();
    const bankSelected = getBankSaved(bankFromUrl, answers.urlParameters);
    const marketSelected = getMarketSaved(answers.urlParameters);
    const [ contactFormProducts, setContactFormProducts ] = useState([]);

    useEffect(() => {
      /**
       * Note:
       * customerAffiliate is being used for populating the bank value on the xml file that is sent to the client when a guide is submitted.
       * In this guide the marketSelected holds the value of the affiliate bank passed on the url params, 
       * while the bankSelected seems to be used to hold the value that controls the theme.
       * As of March 2024 there're only 3 repossible theme options)
       */
      saveAppkey('customerAffiliate', marketSelected);
    }, []);

    useEffect(() => {
        getProductsInTheCart(getProductsInCartMap(productCart, productsList));
    }, [productCart]);

    useEffect(() => {
        setAllCartList(getProductsInCartLists(productsInTheCart, 'all'));
        setContactCartList(getProductsInCartLists(productsInTheCart, 'contact'));
        setApplyCartList(getProductsInCartLists(productsInTheCart, 'apply'));
    }, [productsInTheCart]);

    const addToCart = (productId) => {
        dispatch( updateProductCart( productCart, productId, false) );
    };
    const removeFromCart = (productId) => {
        dispatch( updateProductCart( productCart, productId, true) );
    };
    const addAllProductsToCart = () => {
        dispatch( addAllProducts( productsList) );
    }
    const removeAllProductsFromCart = () => {
        dispatch( addAllProducts([]) );
    }
    const openContactForm = (list) => {
        setContactFormProducts(list);
        setShowContactModal(true);
        setShowCartModal(false);
    }

    return (
        <div className={`${componentClass} ${bankSelected}`} id={componentClass}>
                <div className="mainContainer">
                    <div className={`${componentClass}__header`}>
                        <div className='titleContainer'>
                            <h2 className='title'><NeuroMessage id="summary.portfolio" tagName="span" /> <span className='subtitle'><NeuroMessage id="summary.justForYou" tagName="span" /></span></h2>
                        </div>
                        <div className="title-actions">
                            <RenderOnlyFor forSummaryPage={true}>
                                {productsInTheCart.length === 0 ?
                                    <div className="cartActions">
                                        <button className="btn addAll" onClick={addAllProductsToCart}>
                                            <NeuroMessage id="summary.addAll" tagName="span" />
                                            <i class="fa fa-shopping-cart" aria-hidden="true"/>
                                        </button> 
                                    </div>
                                : 
                                    <div className="cartActions">
                                        <button className="btn remove" id="removeAllCart" onClick={removeAllProductsFromCart}>
                                            <NeuroMessage id="summary.removeAll" tagName="span" />
                                            <i class="fa fa-trash-o" aria-hidden="true"></i>
                                        </button>
                                        <button className="btn shoppingCart" onClick={() => setShowCartModal(!showCartModal)}>
                                            <i class="fa fa-shopping-cart" aria-hidden="true"><div className="productCartSize">{productCart.size}</div></i>
                                        </button> 
                                    </div>
                                }
                            </RenderOnlyFor>
                        </div>
                    </div>

                    <div className={`${componentClass}__products`}>
                        { productsList.map(p => <Product key={ p.id } product={p} addToCart={addToCart} removeFromCart={removeFromCart} bankSelected={bankSelected} productCart={productsInTheCart}/>) }
                    </div>

                    <RenderOnlyFor forSummaryPage={true}>
                        <div className={`${componentClass}__navigation`}>
                            <button className="btn" onClick={goToPreviousPage}>
                                <i class="fa fa-chevron-left"/>
                                <NeuroMessage id="summary.back" tagName="span" />
                            </button>
                        </div>
                    </RenderOnlyFor>
                </div>

                <div className={`${componentClass}__answers`}>
                    <Collapsible trigger={<div className='answersListHeader'><NeuroMessage id="summary.yourAnswers" tagName="span" /><i class="fa fa-chevron-right"/></div>}>
                        <AnswersList linkToQuestion />
                    </Collapsible>
                </div>

                <div className={`${componentClass}__footerCopyright`}>
                    <NeuroMessage id="copyright" tagName="span" />
                    <ReactSVG src={'/classpath/assets/images/fdic-logo.svg'}/>
                    
                </div>
                <CartModal className={bankSelected} active={showCartModal} onCloseModal={() =>setShowCartModal(!showCartModal)} productCart={allCartList} productCartApply={applyCartList} productCartContact={contactCartList} removeFromCart={removeFromCart} openContactForm={openContactForm}/>
                <ContactForm className={`${bankSelected}`} active={ showContactModal } productCart={contactFormProducts} onClose={ () => setShowContactModal(false) } marketSelected={marketSelected} />
                
        </div>
    );
}

export default SummaryPage;

